import { useState } from 'react';
import _ from 'lodash';
import { StyledSyncGitTeamsWizard } from './SyncGitTeamsWizard.style';
import GitOrganizationForm from './GitOrganizationForm';
import SyncGitTeamsForm from './SyncGitTeamsForm';
import { Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Summary from './Summary';
import useGitOrganizationForm from './GitOrganizationForm/useGitOrganizationForm';
import useSyncGitTeamsForm from './SyncGitTeamsForm/useSyncGitTeamsForm';
import useProviderTeams from './useProviderTeams/useProviderTeams';
import { LBGithubIcon } from '@linearb/buzz';

export const WIZARD_STEPS = {
  GIT_ORG_SELECTION: 1,
  TEAMS_PICKER: 2,
  SUMMARY: 3
};

const SyncGitTeamsWizard = ({
  onSubmit,
  onCancel,
  gitSelectedSyncTeamsSetting
}) => {
  const [wizardStep, setWizardStep] = useState(WIZARD_STEPS.GIT_ORG_SELECTION);

  const gitOrgData = useGitOrganizationForm();
  const { sensorAuthId, selectedOrgName } = gitOrgData;

  const { providerTeams, isLoading, loadProviderTeams } = useProviderTeams({
    sensorAuthId,
    orgName: selectedOrgName
  });

  const syncTeamsForm = useSyncGitTeamsForm({
    wizardStep,
    providerTeams,
    sensorAuthId,
    orgName: selectedOrgName,
    gitSelectedSyncTeamsSetting
  });

  const onSave = () =>
    onSubmit({
      selectedTeams: syncTeamsForm.checkedTeams,
      orgName: selectedOrgName,
      sensorAuthId
    });

  return (
    <Padding padding='medium' height='85%'>
      <div className='flex items-center gap-2'>
        <LBGithubIcon className='size-5' />
        <Text size='x-x-large' wieght='400'>
          Add Teams - Sync with GitHub ({wizardStep} of {_.size(WIZARD_STEPS)})
        </Text>
      </div>
      <StyledSyncGitTeamsWizard>
        {wizardStep === WIZARD_STEPS.GIT_ORG_SELECTION && (
          <GitOrganizationForm
            onNext={() => {
              loadProviderTeams();
              setWizardStep(WIZARD_STEPS.TEAMS_PICKER);
            }}
            onCancel={onCancel}
            {...gitOrgData}
          />
        )}
        {wizardStep === WIZARD_STEPS.TEAMS_PICKER && (
          <SyncGitTeamsForm
            orgName={selectedOrgName}
            onNext={() => setWizardStep(WIZARD_STEPS.SUMMARY)}
            onBack={() => setWizardStep(WIZARD_STEPS.GIT_ORG_SELECTION)}
            providerTeams={providerTeams}
            selectedTeam={syncTeamsForm.selectedTeam}
            onClickTeam={syncTeamsForm.onClickTeam}
            toggleTeamCheckbox={syncTeamsForm.toggleTeamCheckbox}
            isTeamChecked={syncTeamsForm.isTeamChecked}
            isTeamChildChecked={syncTeamsForm.isTeamChildChecked}
            total={syncTeamsForm.total}
            isLoading={syncTeamsForm.isCalculatingTotal || isLoading}
            checkedTeams={syncTeamsForm.checkedTeams}
          />
        )}
        {wizardStep === WIZARD_STEPS.SUMMARY && (
          <Summary
            sensorAuthId={sensorAuthId}
            orgName={selectedOrgName}
            selectedTeams={syncTeamsForm.checkedTeams}
            onBack={() => setWizardStep(WIZARD_STEPS.TEAMS_PICKER)}
            onSave={onSave}
          />
        )}
      </StyledSyncGitTeamsWizard>
    </Padding>
  );
};

export default SyncGitTeamsWizard;
